<template>
    <tr>
        <td :class="{'alert-past': isPast}">{{ alert.reminder_date }}</td>
        <td>
            <a v-if="alert.placement" :href="`/placement/edit/${alert.placement_id}`">
                {{ name }}
            </a>
            <a v-else-if="alert.parent && alert.parent_type === 'App\\Company'" :href="`/crm/company/${alert.parent_id}`">
                {{ name }}
            </a>
            <a v-else-if="alert.parent && alert.parent_type === 'App\\Contact'" :href="`/crm/contact/${alert.parent_id}`">
                {{ name }}
            </a>
            <a v-else-if="alert.parent && alert.parent_type === 'App\\Event'" :href="`/crm/event/${alert.parent_id}`">
                {{ name }}
            </a>
            <a v-else-if="alert.parent && alert.parent_type === 'App\\Vendor'" :href="`/crm/vendor/${alert.parent_id}`">
                {{ name }}
            </a>
            <a v-else-if="alert.parent && alert.parent_type === 'App\\Hotel'" :href="`/crm/hotel/${alert.parent_id}`">
                {{ name }}
            </a>
            <span v-else>
                {{ name }}
            </span>
        </td>
        <td>
            <a href="#" @click.prevent="update">{{ alert.name }}</a>
        </td>
        <td>{{ alert.message }}</td>
    </tr>
</template>

<script>
export default {
    props: ["alert", "user"],
    computed: {
        name() {
            if (this.alert.placement && this.alert.placement.policyholder) {
                return this.alert.placement.policyholder.name;
            }

            return this.alert.parent ? this.alert.parent.name : this.alert.custom_item;
        },
        isPast() {
            return moment(this.alert.reminder_date).isBefore(moment());
        },
    },
    methods: {
        update() {
            window.app_data.activeAlert = { ...this.alert };
            window.app_data.activeAlertUser = { ...this.user };
            window.app_data.updatingAlert = false;
            window.app_data.completingAlert = false;
            window.app_data.updateType = [];
            $('.alert-datepicker').val(this.alert.reminder_date);

            if (this.alert.parent_type) {
                const id = this.alert.placement ? this.alert.placement_id : this.alert.parent_id;
                const name = this.alert.placement ? this.alert.placement.policyholder.name : (this.alert.parent ? this.alert.parent.name : '-');
                let model = this.alert.parent_type.replace('App\\', '').toLowerCase();
                if (!['contact', 'company', 'vendor', 'hotel', 'event'].includes(model)) {
                    model = 'placement';
                }
                $(`[data-type="editor-update_alert"] .alert-item-${model} [name="parent_id"]`)
                    .append('<option value="' + id + '">' + name + '</option>')
                    .val(id.toString())
                    .trigger("change")
                    .trigger("change");
            }
            $('[data-type="editor-update_alert"] [name="alert_template_id"]')
                .val(this.alert.name)
                .trigger("change")
                .trigger("change");
            $('[data-type="editor-update_alert"] [name="user_id"]')
                .val(this.alert.user_id.toString())
                .trigger("change")
                .trigger("change");
            popup_open("editor-update_alert");
        }
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/alerts/alert-row.vue